// extracted by mini-css-extract-plugin
export default {"delete-button":"DeleteButton_delete-button__rTk5A","delete-icon":"DeleteButton_delete-icon__6BEdD"};